import {
  ProductAAEHUDFactoryType,
  ProductBundleType,
  ProductType,
} from "types";
import { ProductsIncludeBundles, getProducts } from "utils";

import ContentBox from "components/ContentBox";
import ProductList from "pages/E-Shop/ProductList";
import styled from "styled-components";

const Wrapper = styled.div``;

const DetailIncludedInBundles = (props: {
  product: ProductBundleType | ProductType | ProductAAEHUDFactoryType;
}) => {
  const bundles = getProducts({
    includeBundles: ProductsIncludeBundles.only,
    productId: props.product?.id,
  });

  if (!bundles?.length) {
    return null;
  }

  return (
    <ContentBox title="Bundles">
      <Wrapper>
        <ProductList
          products={bundles}
          productItem={{
            wide: bundles?.length <= 1,
          }}
        />
      </Wrapper>
    </ContentBox>
  );
};

export default DetailIncludedInBundles;
